import React from 'react';
import { Steps } from 'antd';
import { StepsProps } from 'antd/lib/steps';

export type { StepsProps };

const ProSteps: React.FC<StepsProps> = (props) => {
  const { children, ...resProps } = props;

  return (
    <Steps {...resProps}>
      {children}
    </Steps>
  );
};

export default ProSteps;
